import { boolean, partial } from 'io-ts/Decoder';

export const Request = partial({
	/** Also roll back the entities the copy already created. */
	revert: boolean,
});
